import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_select, {
      ref: "select",
      value: _ctx.pageId,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageId) = $event)),
      disabled: _ctx.isDisabled,
      style: {"width":"120px"},
      onChange: _ctx.handleChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printSizeOptions, (page, index) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            value: page.id,
            key: index
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(page.name), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "disabled", "onChange"]),
    _createElementVNode("span", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doPrint(_ctx.pageId)))
    }, "去打印")
  ], 64))
}